import { createReducer, on } from '@ngrx/store';
import * as ridersActions from '../actions/riders.action';
import { RidersState } from '../../models/riders.model';

export const initialState: RidersState = {
  riders: [],
  ridersLocations: [],
  activeRiderLocations: [],
  inactiveRiderLocations: [],
  busyRiderLocations: [],
  riderForm: null,
  selectedRiderId: null,
  rider: null,
  searchedRiders: [],
  error: null,
  loading: false,
  page: 1,
  totalItems: 0,
  totalPages: 0,
 
};

export const ridersReducer = createReducer(
    initialState,
    on(ridersActions.loadAllRiders, (state) => {
        return { ...state, loading: true };
    }),
    on(ridersActions.loadAllRidersSuccess, (state, { riders }) => {
        return {
            ...state,
            riders: riders.items,
            page: riders.page,
            totalItems: riders.total_items,
            totalPages: riders.total_pages,
            loading: false
        };
    }),
    on(ridersActions.loadAllRidersFailure, (state, { error }) => {
        return {
            ...state,
            error,
            loading: false
        };
    }),
    on(ridersActions.searchRidersSuccess, (state, { riders }) => {
        return {
            ...state,
            searchedRiders: riders.items,
            page: riders.page,
            totalItems: riders.total_items,
            totalPages: riders.total_pages
        };
    }),
    on(ridersActions.updatedRider, (state, action) => ({
        ...state,
        rider: action.rider,
    })),
    on(ridersActions.searchRidersFailure, (state, { error }) => {
        return {
            ...state,
            error,
            loading: false
        };
    }),
    on(ridersActions.createRider, (state) => {
        return { ...state, loading: true };
    }),
    on(ridersActions.createRiderSuccess, (state, action) => ({
        ...state,
        loading: false,
        riders: [...state.riders, action.rider]
    })),
    on(ridersActions.loadRidersLocations, (state) => {
        return { 
            ...state, 
            loading: true 
        };
    }),
 
    on(ridersActions.loadRidersLocationsSuccess, (state, { ridersLocations }) => {
        return {
            ...state,
            activeRiderLocations: ridersLocations.filter(r => r.active && !r.service_request_status),
            inactiveRiderLocations: ridersLocations.filter(r => !r.active),
            busyRiderLocations: ridersLocations.filter(r => r.rider_busy),
            loading: false
        };
    }),
    on(ridersActions.loadRidersLocationsFailure, (state, { error }) => {
        return {
            ...state,
            error,
            loading: false
        };
    }),
    on(ridersActions.refreshRiderLocations, (state, { rider_id, latitude, longitude }) => ({
        ...state,
        ridersLocations: state.ridersLocations.map(location =>
          location.rider_id === rider_id
            ? { ...location, latitude: latitude.toString(), longitude: longitude.toString() }
            : location
        ),
        activeRiderLocations: state.activeRiderLocations.map(location =>
            location.rider_id === rider_id
                ? { ...location, latitude: latitude.toString(), longitude: longitude.toString() }
                : location
            ),
        busyRiderLocations: state.busyRiderLocations.map(location =>
            location.rider_id === rider_id
                ? { ...location, latitude: latitude.toString(), longitude: longitude.toString() }
                : location
            ),
      })),
   
    on(ridersActions.createRiderFailure, (state, { error }) => {
        return {
            ...state,
            error,
            loading: false
        };
    }),
    on(ridersActions.editRider, (state) => {
        return { ...state, loading: true };
    }),
    on(ridersActions.editRiderSuccess, (state, { rider }) => {
        return {
            ...state,
            riders: state.riders.map(r => r.id === rider.id ? rider : r),
            loading: false
        };
    }),
    on(ridersActions.editRiderFailure, (state, { error }) => {
        return {
            ...state,
            error,
            loading: false
        };
    }),
    on(ridersActions.deleteRider, (state) => {
        return { ...state, loading: true };
    }),
    on(ridersActions.deleteRiderSuccess, (state, { id }) => {
        return {
            ...state,
            riders: state.riders.filter(r => r.id !== id),
            loading: false
        };
    }),
    on(ridersActions.deleteRiderFailure, (state, { error }) => {
        return {
            ...state,
            error,
            loading: false
        };
    }),
    on(ridersActions.loadRiderById, (state) => {
        return { 
            ...state, 
            loading: true
         };
    }),
    on(ridersActions.loadRiderByIdSuccess, (state, { rider }) => {
        return {
            ...state,
            rider,
            loading: false
        };
    }),
    on(ridersActions.loadRiderByIdFailure, (state, { error }) => {
        return {
            ...state,
            error,
            loading: false
        };
    }),
    on(ridersActions.resetRider, (state) => {
        return {
            ...state,
            rider: null
        };
    }),
    on(ridersActions.selectRider, (state, action) => {
        return {
            ...state,
            isLoading: true,
            selectedRiderId: action.rider_id
        };
    }),
    on(ridersActions.selectRiderSuccess, (state, action) => {
        return {
            ...state,
            rider: action.rider,
            isLoading: false
        };
    }),
    on(ridersActions.selectRiderFailure, (state, action) => {
        return {
            ...state,
            isLoading: false
        };
    }),
    on(ridersActions.markRiderAsBusy, (state, { rider_id }) => {
        const rider = state.activeRiderLocations.find(r => r.rider_id === rider_id);
        if (!rider) return state;
        return {
            ...state,
            activeRiderLocations: state.activeRiderLocations.filter(r => r.rider_id !== rider_id),
            busyRiderLocations: [...state.busyRiderLocations, { ...rider, rider_busy: true, service_request_status: true }]
        };
    }),
);